import React, { useMemo } from 'react';
import './Returns.scss';
import ProFormaReturnsTable from 'components/ProFormaReturnsTable/ProFormaReturnsTable';
import RenderIf from 'components/RenderIf/RenderIf';
import { isEmpty } from 'lodash';
import { useProFormaSocketContext } from '../../ProForma/socketContext/ProFormaSocketProvider';
import { getPeriodKeys, transformReturnsData } from './helpers';

const Returns = () => {
    const {
        returnsData, operatingInfo, showCents, periodCadence, proForma,
    } = useProFormaSocketContext();

    const transformedData = useMemo(() => transformReturnsData(returnsData, periodCadence), [returnsData, periodCadence]);
    const dateKeys = useMemo(() => getPeriodKeys(returnsData, periodCadence), [returnsData, periodCadence]);

    return (
        <RenderIf isTrue={!isEmpty(proForma)} isLoading={isEmpty(proForma)}>
            <div className="Returns">
                {transformedData && (
                    <ProFormaReturnsTable
                        showCents={showCents}
                        propertyReturns={transformedData}
                        dateKeys={dateKeys}
                        operationBeginMonth={operatingInfo.operationBeginMonth || 0}
                        cadence={periodCadence}
                    />
                )}
            </div>
        </RenderIf>
    );
};

export default Returns;
